<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle"><b>The Zoot-Suit Riots</b><a id="page_xvi"></a><a id="page_xvii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292756441_09_htit1.vue?0455f4e8